/* LUMEA — motorul de interacțiune. Vanilla, fără dependențe. */
(function () {
  "use strict";
  var RM = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var FINE = window.matchMedia("(hover:hover) and (pointer:fine)").matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };

  /* ---------- 0. Piață și limbă ----------
     window.LUMEA e injectat de layout/theme.liquid și conține rutele cu prefixul
     pieței (/en-ae/...) plus textele din fișierul de limbă. Fără el, orice URL
     scris de mână trimite cumpărătorul înapoi în piața rădăcină (română). */
  var CFG = (window.LUMEA || {});
  var R = CFG.routes || {};
  var T = CFG.t || {};
  var MONEY = CFG.money || {};
  function ruta(nume, implicit) { return R[nume] || implicit; }
  function txt(cheie, implicit) { var v = T[cheie]; return (v && v.indexOf("ranslation missing") === -1) ? v : implicit; }

  function fmtNum(n, zecimale) {
    try {
      return n.toLocaleString(MONEY.locale || undefined,
        zecimale ? { minimumFractionDigits: 1, maximumFractionDigits: 1 } : { maximumFractionDigits: 0 });
    } catch (e) { return zecimale ? n.toFixed(1) : String(Math.round(n)); }
  }

  /* ---------- 1. Dezvăluire la derulare ---------- */
  function reveal() {
    var els = $$(".rv,.rv-img,.ring,.split,.rule,[data-count]");
    if (!("IntersectionObserver" in window) || RM) {
      els.forEach(function (e) { e.classList.add("in"); });
      $$("[data-count]").forEach(function (e) {
        var brut = e.getAttribute("data-count");
        var n = parseFloat(String(brut).replace(/[^\d.]/g, ""));
        e.textContent = isFinite(n) ? fmtNum(n, n % 1) + String(brut).replace(/^[\d.\s]+/, "") : brut;
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add("in");
        if (en.target.hasAttribute("data-count")) countUp(en.target);
        io.unobserve(en.target);
      });
    }, { rootMargin: "0px 0px -12% 0px", threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });

    /* Plasa de siguranta: daca observatorul nu a apucat sa porneasca elementele
       care sunt DEJA pe ecran la incarcare (fonturi care se schimba, imagini care
       se aseaza, prag neatins), le aratam oricum. Altfel clientul vede pagina goala
       si trebuie sa deruleze ca sa apara titlul si pretul. */
    function aratVizibilele() {
      els.forEach(function (e) {
        if (e.classList.contains("in")) return;
        var r = e.getBoundingClientRect();
        if (r.top < (window.innerHeight || 0) && r.bottom > 0) {
          e.classList.add("in");
          if (e.hasAttribute("data-count")) countUp(e);
          io.unobserve(e);
        }
      });
    }
    setTimeout(aratVizibilele, 700);
    setTimeout(aratVizibilele, 1800);
    window.addEventListener("load", function () { setTimeout(aratVizibilele, 120); });
  }

  function countUp(el) {
    var raw = el.getAttribute("data-count");
    el.textContent = "0";
    var target = parseFloat(String(raw).replace(/[^\d.]/g, ""));
    if (!isFinite(target)) { el.textContent = raw; return; }
    var suffix = String(raw).replace(/^[\d.\s]+/, "");
    var t0 = null, dur = 1400;
    function step(t) {
      if (t0 === null) t0 = t;
      var p = clamp((t - t0) / dur, 0, 1);
      var e = 1 - Math.pow(1 - p, 3);
      var v = target * e;
      el.textContent = fmtNum(v, target % 1) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
    setTimeout(function () {
      var cur = parseFloat(String(el.textContent).replace(/[^\d.]/g, ""));
      if (!isFinite(cur) || Math.abs(cur - target) > 0.51) {
        el.textContent = fmtNum(target, target % 1) + suffix;
      }
    }, dur + 260);
  }

  /* ---------- 2. Antet ---------- */
  function header() {
    var h = $(".hdr"); if (!h) return;
    var last = 0;
    var faraErou = document.body.classList.contains("no-hero");
    function on() {
      var y = window.scrollY || 0;
      h.classList.toggle("solid", faraErou || y > 30);
      /* lipirea de marginea de sus e legata DOAR de derulare, nu de fundal:
         pe paginile fara erou fundalul e mereu opac, dar banda de anunt trebuie sa ramana vizibila */
      h.classList.toggle("lipit", y > 30);
      if (!document.body.classList.contains("nav-open")) {
        h.classList.toggle("up", y > last && y > 420);
      }
      last = y;
    }
    on();
    window.addEventListener("scroll", on, { passive: true });

    var b = $(".burger");
    var mnav = $(".mnav");
    function setNav(open) {
      document.body.classList.toggle("nav-open", open);
      if (b) b.setAttribute("aria-expanded", open ? "true" : "false");
      document.documentElement.style.overflow = open ? "hidden" : "";
      if (mnav) mnav.setAttribute("aria-hidden", open ? "false" : "true");
      /* restul paginii devine inaccesibil cu tastatura */
      ["main", "footer", ".ftr", ".sticky"].forEach(function (sel) {
        var el = document.querySelector(sel);
        if (el) { if (open) el.setAttribute("inert", ""); else el.removeAttribute("inert"); }
      });
      if (open && mnav) { var f = mnav.querySelector("a"); if (f) f.focus(); }
      else if (b) b.focus();
    }
    if (b) b.addEventListener("click", function () { setNav(!document.body.classList.contains("nav-open")); });
    if (mnav) {
      mnav.setAttribute("aria-hidden", "true");
      mnav.addEventListener("keydown", function (e) {
        if (e.key !== "Tab") return;
        var f = $$("a,button", mnav).filter(function (x) { return x.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }
    $$(".mnav a").forEach(function (a) { a.addEventListener("click", function () { setNav(false); }); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && document.body.classList.contains("nav-open")) setNav(false);
    });
  }

  /* ---------- 3. Halou după cursor ---------- */
  function cursorGlow() {
    if (!FINE || RM) return;
    var el = document.createElement("div");
    el.className = "cursor-glow";
    document.body.appendChild(el);
    var x = innerWidth / 2, y = innerHeight / 2, cx = x, cy = y, on = false, raf = 0;
    function loop() {
      cx += (x - cx) * 0.12; cy += (y - cy) * 0.12;
      el.style.transform = "translate3d(" + cx.toFixed(1) + "px," + cy.toFixed(1) + "px,0)";
      raf = requestAnimationFrame(loop);
    }
    window.addEventListener("mousemove", function (e) {
      x = e.clientX; y = e.clientY;
      if (!on) { on = true; el.classList.add("on"); loop(); }
    }, { passive: true });
    document.addEventListener("mouseleave", function () { el.classList.remove("on"); });
    document.addEventListener("mouseenter", function () { if (on) el.classList.add("on"); });
  }

  /* ---------- 4. Câmpul de lumină (canvas) ---------- */
  function lightField() {
    var cv = $(".hero__canvas"); if (!cv) return;
    var ctx = cv.getContext("2d", { alpha: true });
    var SC = 0.22, W = 0, H = 0, blobs = [], run = true, raf = 0, t = 0;

    function colors() {
      var cs = getComputedStyle(document.documentElement);
      return {
        a: (cs.getPropertyValue("--glow") || "#FF3B30").trim(),
        b: (cs.getPropertyValue("--gold") || "#C9A24B").trim()
      };
    }
    function hexA(hex, a) {
      hex = hex.replace("#", "");
      if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      var n = parseInt(hex, 16);
      return "rgba(" + ((n >> 16) & 255) + "," + ((n >> 8) & 255) + "," + (n & 255) + "," + a + ")";
    }
    function size() {
      var r = cv.getBoundingClientRect();
      W = Math.max(1, Math.round(r.width * SC));
      H = Math.max(1, Math.round(r.height * SC));
      cv.width = W; cv.height = H;
    }
    function build() {
      var c = colors();
      blobs = [
        { x: .30, y: .34, r: .52, c: c.a, o: .58, sx: .00021, sy: .00013, px: 0, py: 1.4 },
        { x: .72, y: .58, r: .44, c: c.a, o: .34, sx: .00016, sy: .00019, px: 2.1, py: .4 },
        { x: .52, y: .18, r: .38, c: c.b, o: .26, sx: .00011, sy: .00009, px: 1.1, py: 2.7 },
        { x: .82, y: .74, r: .40, c: c.b, o: .18, sx: .00014, sy: .00012, px: 3.3, py: 1.9 },
        { x: .86, y: .16, r: .30, c: c.a, o: .22, sx: .00018, sy: .00015, px: .6, py: 3.1 }
      ];
    }
    function draw(now) {
      if (!run) return;
      t = now || 0;
      ctx.clearRect(0, 0, W, H);
      ctx.globalCompositeOperation = "lighter";
      for (var i = 0; i < blobs.length; i++) {
        var b = blobs[i];
        var bx = (b.x + Math.sin(t * b.sx + b.px) * .085) * W;
        var by = (b.y + Math.cos(t * b.sy + b.py) * .075) * H;
        var br = b.r * Math.max(W, H) * (1 + Math.sin(t * .00013 + i) * .06);
        var g = ctx.createRadialGradient(bx, by, 0, bx, by, br);
        g.addColorStop(0, hexA(b.c, b.o));
        g.addColorStop(.45, hexA(b.c, b.o * .32));
        g.addColorStop(1, hexA(b.c, 0));
        ctx.fillStyle = g;
        ctx.beginPath(); ctx.arc(bx, by, br, 0, 6.2832); ctx.fill();
      }
      ctx.globalCompositeOperation = "source-over";
      raf = requestAnimationFrame(draw);
    }

    size(); build();
    cv.style.filter = "blur(22px)";
    if (RM) { draw(0); cancelAnimationFrame(raf); }
    else { raf = requestAnimationFrame(draw); }

    var to;
    window.addEventListener("resize", function () {
      clearTimeout(to); to = setTimeout(function () { size(); }, 180);
    }, { passive: true });

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) { run = false; cancelAnimationFrame(raf); }
      else if (!RM) { run = true; raf = requestAnimationFrame(draw); }
    });

    if ("IntersectionObserver" in window && !RM) {
      new IntersectionObserver(function (e) {
        var vis = e[0].isIntersecting;
        if (vis && !run) { run = true; raf = requestAnimationFrame(draw); }
        if (!vis && run) { run = false; cancelAnimationFrame(raf); }
      }, { threshold: 0 }).observe(cv);
    }

    window.LUMEA_REBUILD_FIELD = build;
  }

  /* ---------- 5. Spectrul celor 7 lumini ---------- */
  function spectrum() {
    var root = $("[data-spectrum]"); if (!root) return;
    var sw = $$(".swatch", root);
    var nm = $(".spec__nm", root), name = $(".spec__name", root), desc = $(".spec__desc", root);
    var tint = $(".spec__tint", root), bg = $(".spec__bg", root), halo = $(".spec__halo", root);
    var timer = null, i = 0;

    function apply(btn, user) {
      var c = btn.getAttribute("data-c");
      var soft = btn.getAttribute("data-soft") || c;
      var rs = document.documentElement.style;
      rs.setProperty("--glow", c);
      rs.setProperty("--glow-soft", soft);
      rs.setProperty("--glow-dim", btn.getAttribute("data-dim") || soft);
      sw.forEach(function (s) { s.setAttribute("aria-selected", s === btn ? "true" : "false"); });
      if (nm) {
        var val = btn.getAttribute("data-nm") || "";
        var areCifre = /\d/.test(val);
        nm.innerHTML = areCifre ? (val + "<sub>nm</sub>") : val;
        nm.classList.toggle("spec__nm--tx", !areCifre);
        nm.classList.remove("spec__fade"); void nm.offsetWidth; nm.classList.add("spec__fade");
      }
      if (name) {
        name.textContent = btn.getAttribute("data-name");
        name.classList.remove("spec__fade"); void name.offsetWidth; name.classList.add("spec__fade");
      }
      if (desc) {
        desc.textContent = btn.getAttribute("data-desc");
        desc.classList.remove("spec__fade"); void desc.offsetWidth; desc.classList.add("spec__fade");
      }
      var hue = btn.getAttribute("data-hue");
      var mk = $(".spec__mask", root);
      if (mk && hue !== null) mk.style.filter = "drop-shadow(0 30px 56px rgba(0,0,0,.8)) hue-rotate(" + hue + "deg)";
      if (tint) tint.style.background = c;
      if (halo) halo.style.background = "radial-gradient(circle," + c + " 0%, transparent 66%)";
      if (bg) bg.style.background = "radial-gradient(60% 55% at 50% 45%," + (btn.getAttribute("data-dim") || soft) + " 0%, transparent 70%)";
      if (window.LUMEA_REBUILD_FIELD) window.LUMEA_REBUILD_FIELD();
      if (user) stop();
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    var ture = 0;
    function auto() {
      if (RM || !sw.length) return;
      stop();
      timer = setInterval(function () {
        i = (i + 1) % sw.length;
        if (i === 0) { ture++; if (ture >= 1) { stop(); return; } }
        apply(sw[i], false);
      }, 4600);
    }
    root.addEventListener("mouseenter", stop);
    root.addEventListener("focusin", stop);
    root.addEventListener("touchstart", stop, { passive: true });

    sw.forEach(function (b, k) {
      b.addEventListener("click", function () { i = k; apply(b, true); });
      b.addEventListener("mouseenter", function () { if (FINE) { i = k; apply(b, true); } });
      b.addEventListener("keydown", function (e) {
        var d = e.key === "ArrowRight" ? 1 : e.key === "ArrowLeft" ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        i = (k + d + sw.length) % sw.length;
        sw[i].focus(); apply(sw[i], true);
      });
    });
    if (sw.length) apply(sw[0], false);

    function resetGlow() {
      var rs = document.documentElement.style;
      rs.setProperty("--glow", "#E0342A");
      rs.setProperty("--glow-soft", "rgba(224,52,42,.38)");
      rs.setProperty("--glow-dim", "rgba(224,52,42,.12)");
      if (window.LUMEA_REBUILD_FIELD) window.LUMEA_REBUILD_FIELD();
    }
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (e) {
        if (e[0].isIntersecting) { if (!timer) auto(); }
        else { stop(); resetGlow(); }
      }, { threshold: .3 }).observe(root);
    }
  }

  /* ---------- 6. Selector de variante ---------- */
  function variantPicker() {
    var form = $("[data-variants]"); if (!form) return;
    var dataEl = $("[data-variant-data]"); if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idField = $("[data-variant-id]", form);
    var btn = $("[data-add]", form);
    var btnTx = $("[data-add-tx]", form);
    var selects = $$("select[data-opt]", form);
    if (!selects.length || !idField) return;

    function money(cents) {
      var suma = cents / 100;
      try {
        return new Intl.NumberFormat(MONEY.locale || undefined, {
          style: "currency",
          currency: MONEY.currency || "RON",
          minimumFractionDigits: suma % 1 === 0 ? 0 : 2,
          maximumFractionDigits: 2
        }).format(suma);
      } catch (e) {
        return suma.toFixed(2) + " " + (MONEY.currency || "");
      }
    }
    function upd() {
      var chosen = selects.map(function (s) { return s.value; });
      var v = null;
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var k = 0; k < chosen.length; k++) {
          if (variants[i].options[k] !== chosen[k]) { ok = false; break; }
        }
        if (ok) { v = variants[i]; break; }
      }
      if (!v) {
        if (btn) btn.disabled = true;
        if (btnTx) btnTx.textContent = txt("comboUnavailable", "Unavailable");
        return;
      }
      idField.value = v.id;
      if (btn) btn.disabled = !v.available;
      if (btnTx) btnTx.textContent = v.available ? (txt("addToCart", "Add to cart") + " \u2014 " + money(v.price)) : txt("soldOut", "Sold out");
      var price = $(".buy__price b");
      if (price) price.textContent = money(v.price);
      var cmp = $(".buy__price s");
      if (cmp) {
        if (v.compare_at_price && v.compare_at_price > v.price) { cmp.textContent = money(v.compare_at_price); cmp.style.display = ""; }
        else cmp.style.display = "none";
      }
      if (history.replaceState) {
        var u = new URL(location.href); u.searchParams.set("variant", v.id);
        history.replaceState({}, "", u.toString());
      }
    }
    selects.forEach(function (s) { s.addEventListener("change", upd); });
    upd();
  }

  /* ---------- 7. Bara fixă de cumpărare ---------- */
  /* întrebările frecvente scrise ca h3 + paragrafe devin acordeon */
  function pageFaq() {
    var host = $(".pg__faq"); if (!host) return;
    $$("h3", host).forEach(function (h) {
      var d = document.createElement("details");
      var s = document.createElement("summary");
      s.textContent = h.textContent;
      d.appendChild(s);
      var a = document.createElement("div");
      a.className = "faq__a";
      var n = h.nextSibling;
      while (n && !(n.nodeType === 1 && /^H[123]$/.test(n.tagName))) {
        var nx = n.nextSibling; a.appendChild(n); n = nx;
      }
      d.appendChild(a);
      h.parentNode.replaceChild(d, h);
    });
  }

  function stickyBar() {
    var bar = $(".sticky"); if (!bar) return;
    var anchor = $("[data-sticky-after]");
    if (!anchor || !("IntersectionObserver" in window)) {
      var onScroll = function () { bar.classList.toggle("on", (window.scrollY || 0) > 520); };
      onScroll(); window.addEventListener("scroll", onScroll, { passive: true });
      return;
    }
    new IntersectionObserver(function (e) {
      bar.classList.toggle("on", !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(anchor);
  }

  /* ---------- 8. Bandă infinită ---------- */
  function marquee() {
    $$(".ann__tx,[data-marquee]").forEach(function (m) {
      if (m.dataset.dup) return;
      m.dataset.dup = "1";
      m.innerHTML = m.innerHTML + m.innerHTML;
    });
  }

  /* ---------- 9. Parallax fin ---------- */
  function parallax() {
    var els = $$("[data-par]");
    if (!els.length || RM) return;
    var ticking = false;
    function upd() {
      var vh = innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var k = parseFloat(el.getAttribute("data-par")) || .08;
        var mid = r.top + r.height / 2 - vh / 2;
        el.style.transform = "translate3d(0," + (-mid * k).toFixed(2) + "px,0)";
      });
      ticking = false;
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { ticking = true; requestAnimationFrame(upd); }
    }, { passive: true });
    upd();
  }

  /* ---------- 10. Erou gata ---------- */
  function heroReady() {
    var h = $(".hero"); if (!h) return;
    var img = $(".hero__media img", h);
    function go() { h.classList.add("ready"); $$(".split,.rv", h).forEach(function (e) { e.classList.add("in"); }); }
    if (!img || img.complete) setTimeout(go, 60);
    else { img.addEventListener("load", go); setTimeout(go, 1400); }
  }


  /* ---------- 11. APRINDEREA CELOR 180 ---------- */
  function ignite180() {
    var figs = $$("[data-ignite]");
    if (!figs.length) return;

    /* silueta măștii, normalizată 0..1 */
    var OUT = [[.50,.015],[.66,.035],[.79,.10],[.88,.21],[.925,.35],[.915,.49],
               [.865,.63],[.775,.77],[.655,.885],[.55,.965],[.45,.965],[.345,.885],
               [.225,.77],[.135,.63],[.085,.49],[.075,.35],[.12,.21],[.21,.10],[.34,.035]];
    /* decupaje: ochi stâng, ochi drept, gură, nas */
    var HOLES = [[.335,.375,.105,.052],[.665,.375,.105,.052],[.5,.735,.125,.058],[.5,.53,.045,.10]];

    function inPoly(x, y, p) {
      var c = false;
      for (var i = 0, j = p.length - 1; i < p.length; j = i++) {
        if (((p[i][1] > y) !== (p[j][1] > y)) &&
            (x < (p[j][0] - p[i][0]) * (y - p[i][1]) / (p[j][1] - p[i][1]) + p[i][0])) c = !c;
      }
      return c;
    }
    function inHole(x, y) {
      for (var i = 0; i < HOLES.length; i++) {
        var h = HOLES[i], dx = (x - h[0]) / h[2], dy = (y - h[1]) / h[3];
        if (dx * dx + dy * dy < 1) return true;
      }
      return false;
    }
    /* Punctele se generează în PERECHI OGLINDITE față de axa verticală, iar surplusul
       se taie tot în perechi, de jos în sus. Altfel tăierea la 180 reteza ultimele puncte
       din rândul de jos (colțul din dreapta) și lăsa unul singur în stânga — ilustrația ieșea strâmbă. */
    function symGrid(step) {
      var pairs = [], singles = [], row = 0, total = 0;
      for (var y = 0.03; y < 0.98; y += step * 0.88) {
        var half = (row % 2) ? 0.5 : 0;
        for (var m = 0; m < 40; m++) {
          var dx = (m + half) * step;
          if (dx < 1e-9) {
            if (inPoly(0.5, y, OUT) && !inHole(0.5, y)) { singles.push([0.5, y]); total++; }
            continue;
          }
          var xl = 0.5 - dx, xr = 0.5 + dx;
          if (xl < 0.02 && xr > 0.98) break;
          if (xl > 0.02 && xr < 0.98 &&
              inPoly(xl, y, OUT) && !inHole(xl, y) &&
              inPoly(xr, y, OUT) && !inHole(xr, y)) {
            pairs.push([[xl, y], [xr, y]]); total += 2;
          }
        }
        row++;
      }
      return { pairs: pairs, singles: singles, total: total };
    }
    function makePoints(target) {
      var best = null, bestDiff = 1e9;
      for (var step = 0.085; step > 0.028; step -= 0.0012) {
        var g = symGrid(step), d = Math.abs(g.total - target);
        if (d < bestDiff) { bestDiff = d; best = g; }
        if (g.total >= target) break;
      }
      var pairs = best.pairs.slice(), singles = best.singles.slice(), total = best.total;
      /* surplusul se ia de jos, simetric */
      pairs.sort(function (a, b) {
        return (b[0][1] - a[0][1]) || (Math.abs(b[0][0] - .5) - Math.abs(a[0][0] - .5));
      });
      singles.sort(function (a, b) { return b[1] - a[1]; });
      while (total - target >= 2 && pairs.length) { pairs.shift(); total -= 2; }
      while (total > target && singles.length) { singles.shift(); total -= 1; }
      var out = [];
      pairs.forEach(function (pr) { out.push(pr[0], pr[1]); });
      singles.forEach(function (sg) { out.push(sg); });
      return out;
    }
    var PTS = makePoints(180);

    /* sprite de lumină pre-randat */
    function sprite(color, size) {
      var c = document.createElement("canvas"); c.width = c.height = size;
      var x = c.getContext("2d"), g = x.createRadialGradient(size/2, size/2, 0, size/2, size/2, size/2);
      g.addColorStop(0, "rgba(255,255,255,.95)");
      g.addColorStop(.18, color);
      g.addColorStop(.5, color.replace("rgb(", "rgba(").replace(")", ",.35)"));
      g.addColorStop(1, "rgba(0,0,0,0)");
      x.fillStyle = g; x.fillRect(0, 0, size, size);
      return c;
    }
    function rgbOf(hex) {
      hex = (hex || "#FF3B30").trim().replace("#", "");
      if (hex.length === 3) hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
      var n = parseInt(hex, 16);
      return "rgb(" + ((n>>16)&255) + "," + ((n>>8)&255) + "," + (n&255) + ")";
    }

    figs.forEach(function (fig) {
      var cv = $("canvas", fig); if (!cv) return;
      var ctx = cv.getContext("2d");
      var counter = $("[data-lb-count]", fig);
      var W = 0, H = 0, DPR = Math.min(window.devicePixelRatio || 1, 2);
      var sp = null, spColor = "";
      var t0 = null, started = false, raf = 0, done = false;
      var order = PTS.map(function (p, i) {
        var d = Math.hypot(p[0] - .5, p[1] - .5);
        return { x: p[0], y: p[1], d: d, i: i, ph: Math.random() * 6.28, sp: .7 + Math.random() * .7 };
      }).sort(function (a, b) { return a.d - b.d; });
      order.forEach(function (p, k) { p.delay = 240 + k * 6.4; });

      function size() {
        var r = cv.getBoundingClientRect();
        W = Math.max(1, r.width); H = Math.max(1, r.height);
        cv.width = W * DPR; cv.height = H * DPR;
        ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      }
      function ensureSprite() {
        var col = rgbOf(getComputedStyle(document.documentElement).getPropertyValue("--glow"));
        if (col !== spColor) { spColor = col; sp = sprite(col, 96); }
      }
      function frame(now) {
        if (t0 === null) t0 = now;
        var t = now - t0;
        ensureSprite();
        ctx.clearRect(0, 0, W, H);
        ctx.globalCompositeOperation = "lighter";
        var pad = 0.06, sx = W * (1 - pad * 2), sy = H * (1 - pad * 2), ox = W * pad, oy = H * pad;
        var lit = 0, base = Math.min(W, H) * 0.052;
        for (var k = 0; k < order.length; k++) {
          var p = order[k];
          var a = (t - p.delay) / 460;
          if (a <= 0) continue;
          lit++;
          a = a > 1 ? 1 : a;
          var e = 1 - Math.pow(1 - a, 3);
          var fl = done ? (0.78 + 0.22 * Math.sin(now * 0.0013 * p.sp + p.ph)) : 1;
          if (done) {
            var faza = ((now - t0) % 5200) / 5200;
            var raza = faza * 0.62;
            var dd = p.d - raza;
            fl += Math.exp(-(dd * dd) / 0.0022) * 0.85;
          }
          var al = e * fl * 0.9;
          var s = base * (0.55 + e * 0.45);
          ctx.globalAlpha = al;
          ctx.drawImage(sp, ox + p.x * sx - s, oy + p.y * sy - s, s * 2, s * 2);
        }
        ctx.globalAlpha = 1;
        ctx.globalCompositeOperation = "source-over";
        if (counter && !done) counter.textContent = lit < 100 ? ("0" + lit).slice(-3) : String(lit);
        if (!done && lit >= order.length && t > 1500) { done = true; fig.classList.add("lit"); }
        raf = requestAnimationFrame(frame);
      }
      function start() {
        if (started) return; started = true;
        /* plasă: dacă tabul e în fundal, rAF nu rulează niciodată —
           obiectul trebuie să apară oricum */
        setTimeout(function () {
          if (!fig.classList.contains("lit")) {
            fig.classList.add("lit");
            if (counter) counter.textContent = String(order.length);
            done = true;
          }
        }, 2600);
        /* garanție finală: dacă din orice motiv masca a rămas invizibilă
           (recalculare de stil ratată, tab în fundal, rAF încetinit),
           o arătăm direct. Inline bate orice regulă de stil. */
        [4200, 8000].forEach(function (ms) {
          setTimeout(function () {
            var mk = fig.querySelector(".lb-mask");
            if (!mk) return;
            if (parseFloat(getComputedStyle(mk).opacity) < 0.95) {
              mk.style.opacity = "1";
              mk.style.transform = "none";
            }
            if (counter && done) counter.textContent = String(order.length);
          }, ms);
        });
        if (RM) {
          size(); ensureSprite();
          t0 = -99999; fig.classList.add("lit");
          if (counter) counter.textContent = String(order.length);
          ctx.globalCompositeOperation = "lighter";
          var pad = .06, sx = W*(1-pad*2), sy = H*(1-pad*2), ox = W*pad, oy = H*pad, s = Math.min(W,H)*.052;
          ctx.globalAlpha = .85;
          order.forEach(function (p) { ctx.drawImage(sp, ox+p.x*sx-s, oy+p.y*sy-s, s*2, s*2); });
          ctx.globalAlpha = 1; ctx.globalCompositeOperation = "source-over";
          return;
        }
        size(); raf = requestAnimationFrame(frame);
      }
      size();
      var to; window.addEventListener("resize", function () {
        clearTimeout(to); to = setTimeout(size, 200);
      }, { passive: true });
      document.addEventListener("visibilitychange", function () {
        if (document.hidden) { cancelAnimationFrame(raf); return; }
        if (!started || RM) return;
        if (done) { t0 = null; }
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function (n) { if (t0 === null) t0 = n - 2200; frame(n); });
      });
      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (e, o) {
          if (e[0].isIntersecting) { start(); o.disconnect(); }
        }, { threshold: .25 }).observe(fig);
      } else start();
    });
  }

  /* ---------- 12. Inele de progres ---------- */
  function rings() {
    $$(".ring").forEach(function (r) {
      var c = $("circle.fg", r); if (!c) return;
      var rad = parseFloat(c.getAttribute("r")) || 45;
      r.style.setProperty("--c", (2 * Math.PI * rad).toFixed(2));
    });
  }

  /* ---------- 13. Coș fără reîncărcare ---------- */
  function ajaxCart() {
    var forms = $$('form[action*="/cart/add"]');
    if (!forms.length || !window.fetch) return;

    var toast = null;
    function arata(titlu, ok) {
      if (!toast) {
        toast = document.createElement("div");
        toast.className = "toast";
        toast.setAttribute("role", "status");
        toast.setAttribute("aria-live", "polite");
        document.body.appendChild(toast);
      }
      toast.innerHTML = ok
        ? '<b>' + titlu + '</b><span>' + txt("added", "was added to your cart") + '</span>' +
          '<a class="btn" href="' + ruta("cart", "/cart") + '">' + txt("viewCart", "View cart") + '</a>'
        : '<b>' + titlu + '</b>';
      toast.classList.add("on");
      clearTimeout(toast._t);
      toast._t = setTimeout(function () { toast.classList.remove("on"); }, 6000);
    }
    function contor(n) {
      var c = $(".hdr__cart");
      if (!c) return;
      var b = $("span", c);
      if (!b) { b = document.createElement("span"); c.appendChild(b); }
      b.textContent = n;
    }

    forms.forEach(function (f) {
      f.addEventListener("submit", function (e) {
        var btn = f.querySelector('button[type="submit"], button:not([type])');
        if (!btn || btn.disabled) return;
        e.preventDefault();
        var tx = btn.querySelector("[data-add-tx]") || btn;
        var vechi = tx.textContent;
        btn.disabled = true; tx.textContent = txt("adding", "Adding\u2026");
        fetch(ruta("cartAddJs", "/cart/add.js"), { method: "POST", body: new FormData(f), headers: { Accept: "application/json" } })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.j && res.j.description ? res.j.description : txt("addError", "We could not add it to the cart"));
            arata(res.j.product_title || txt("productFallback", "The product"), true);
            return fetch(ruta("cartJs", "/cart.js"), { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
          })
          .then(function (c) { if (c) contor(c.item_count); })
          .catch(function (err) { arata(String(err.message || txt("addError", "We could not add it to the cart")), false); })
          .then(function () { btn.disabled = false; tx.textContent = vechi; });
      });
    });
  }

  /* ---------- 14. Halou după cursor ---------- */
  function cursorGlow() {
    if (!FINE || RM) return;
    var zone = $$(".t-dark, .hero, .final, .mq");
    if (!zone.length) return;
    var el = document.createElement("div");
    el.className = "cursor-glow";
    document.body.appendChild(el);
    var x = 0, y = 0, cx = 0, cy = 0, run = false, raf = 0;
    function loop() {
      cx += (x - cx) * .12; cy += (y - cy) * .12;
      el.style.transform = "translate3d(" + cx.toFixed(1) + "px," + cy.toFixed(1) + "px,0)";
      raf = requestAnimationFrame(loop);
    }
    window.addEventListener("mousemove", function (e) {
      x = e.clientX; y = e.clientY;
      var peste = false;
      for (var i = 0; i < zone.length; i++) {
        var r = zone[i].getBoundingClientRect();
        if (y >= r.top && y <= r.bottom) { peste = true; break; }
      }
      el.classList.toggle("on", peste);
      if (!run) { run = true; cx = x; cy = y; loop(); }
    }, { passive: true });
    document.addEventListener("mouseleave", function () { el.classList.remove("on"); });
  }

  /* ---------- 14b. Preferințe cookie ----------
     Butonul din subsol există doar dacă interfața de consimțământ a Shopify
     chiar e încărcată; altfel politica ar promite un control inexistent. */
  function cookiePrefs() {
    var li = $("[data-cookie-prefs]"); if (!li) return;
    function api() {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === "function") return window.privacyBanner.showPreferences.bind(window.privacyBanner);
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.showPreferences === "function") return cp.showPreferences.bind(cp);
      return null;
    }
    var incercari = 0;
    var t = setInterval(function () {
      var f = api();
      if (f) {
        clearInterval(t);
        li.hidden = false;
        li.querySelector("button").addEventListener("click", function () { f(); });
      } else if (++incercari > 20) {
        clearInterval(t);
      }
    }, 300);
  }

  /* ---------- 15. Cod de reducere ---------- */
  function promo() {
    $$("[data-promo]").forEach(function (b) {
      var eticheta = b.querySelector("b");
      if (!eticheta) return;
      /* eticheta originală se citește O SINGURĂ DATĂ, altfel a doua apăsare
         în interiorul celor 2,2 secunde o înlocuiește definitiv cu „Copiat". */
      var original = eticheta.textContent;
      var ceas = null;
      b.addEventListener("click", function () {
        var cod = b.getAttribute("data-promo");
        var gata = function () {
          eticheta.textContent = txt("copied", "Copied");
          b.classList.add("copiat");
          clearTimeout(ceas);
          ceas = setTimeout(function () { eticheta.textContent = original; b.classList.remove("copiat"); }, 2200);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(cod).then(gata, function () {});
        } else {
          var t = document.createElement("textarea");
          t.value = cod; t.style.position = "fixed"; t.style.opacity = "0";
          document.body.appendChild(t); t.select();
          try { document.execCommand("copy"); gata(); } catch (e) {}
          document.body.removeChild(t);
        }
      });
    });
  }

  /* ---------- 16. Bara de progres ---------- */
  function progress() {
    var b = document.createElement("div");
    b.className = "prog"; b.setAttribute("aria-hidden", "true");
    document.body.appendChild(b);
    var tick = false;
    function upd() {
      var h = document.documentElement.scrollHeight - innerHeight;
      b.style.transform = "scaleX(" + (h > 0 ? clamp(scrollY / h, 0, 1) : 0) + ")";
      tick = false;
    }
    window.addEventListener("scroll", function () {
      if (!tick) { tick = true; requestAnimationFrame(upd); }
    }, { passive: true });
    upd();
  }

  /* ---------- pornire ---------- */
  function init() {
    marquee(); header(); heroReady(); reveal();
    lightField(); ignite180(); rings(); spectrum(); variantPicker(); stickyBar(); parallax(); progress(); ajaxCart(); promo(); cookiePrefs(); cursorGlow(); pageFaq();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
